const HOUR_IN_MS = 60 * 60 * 1000;

export type RelativeHealthTimeline = {
	todayHours: number[];
	currentMonthDays: number[];
	previousMonths: number[];
};

export function createRelativeHealthTimeline(referenceDate = new Date()): RelativeHealthTimeline {
	const now = new Date(referenceDate);
	const startOfToday = new Date(now);
	startOfToday.setHours(0, 0, 0, 0);

	const todayHours = Array.from({ length: now.getHours() + 1 }, (_, hour) => {
		return startOfToday.getTime() + hour * HOUR_IN_MS;
	});

	const currentMonthDays = Array.from({ length: Math.max(now.getDate() - 1, 0) }, (_, index) => {
		return new Date(now.getFullYear(), now.getMonth(), index + 1, 12, 0, 0, 0).getTime();
	});

	const previousMonths = Array.from({ length: 11 }, (_, index) => {
		const monthsAgo = 11 - index;
		return new Date(now.getFullYear(), now.getMonth() - monthsAgo, 15, 12, 0, 0, 0).getTime();
	});

	return {
		todayHours,
		currentMonthDays,
		previousMonths
	};
}
